import React, { useContext, useState, useEffect } from 'react'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import PropTypes from 'prop-types'
import { handleRedirectInternal } from '@/product/common/components'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import Loaders from '@/product/components/molecules/Loaders'
import AsinContext from '@/product/context/thirdParty/asin/asinContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AiView from './AiView'
import '../Product.css'
import AlertContext from '@/product/context/alert/alertContext'
import NoRecordsFound from '@/product/components/atoms/NoRecordsFound'
import { LinearProgress } from '@mui/material'
import ControlHubContext from '@/product/context/controlHub/controlHubContext'
import { useHistory } from 'react-router-dom'

let randomVariable = Math.random()
const showPluginCount = ['ai_search']
const AiSearch = (props) => {
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(false)
    const asinContext = useContext(AsinContext)
    const controlHubContext = useContext(ControlHubContext)
    const { getTableDataDynamic, table_data } = controlHubContext
    const [pluginCountDetails, setPluginCountDetails] = useState(null)
    const {
        ai_products,
        getVinSearch,
        getAiSearch,
        getImageSearch,
        vin_products,
        image_products,
    } = asinContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [tableBody, setTableBody] = useState([])
    const [value, setValue] = useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue)
        closeFunction(true)
    }
    const data = props.data
    const toggleCatalogPopup = props.function

    const validationArray = Yup.object({
        title: Yup.string().required('Required!'),
    })
    const validationArrayImage = Yup.object({
        filename: Yup.array().required('Required!'),
    })
    const formik = useFormik({
        initialValues: {
            title: '',
            filename: '',
        },
        validationSchema: value == 2 ? validationArrayImage : validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            randomVariable = Math.random()
            let data = {}
            if (value == 1) {
                data.vin_search = true
                data.title = values.title
                getVinSearch(data, randomVariable)
            } else if (value == 2) {
                data.filename = values.filename[0]
                getImageSearch(data, randomVariable)
            } else {
                data.title = values.title
                getAiSearch(data, randomVariable)
            }

            setTimeout(() => {
                setIsLoading(false)
            }, 5000)
        },
    })
    const updateCount = (data) => {
        if (showPluginCount.length && showPluginCount.includes(data)) {
            if (pluginCountDetails && pluginCountDetails[data]) {
                let plugin = pluginCountDetails[data]

                let plusCount = parseInt(plugin.used, 10) + 1
                let maxCount = parseInt(plugin.limit, 10)
                let pluginValue = {
                    limit: maxCount,
                    used: plusCount,
                    balance: maxCount <= plusCount ? 0 : maxCount - plusCount,
                    enable: maxCount <= plusCount ? 0 : 1,
                    percent: (plusCount / maxCount) * 100,
                }
                // let newObj=pluginCountDetails

                setPluginCountDetails((ele) => {
                    let temp = { ...ele }
                    temp[data] = pluginValue
                    return temp
                })
            }
        }
    }

    function TabPanel(props) {
        const { children, value, index, ...other } = props

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <div>{children}</div>}
            </div>
        )
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Search',
                placeholder: 'Search title keyword here',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'title',
            },
        ],
    }
    const searchInfoImage = {
        formik: formik,
        data: [
            {
                label: 'Search',
                placeholder: 'Search title keyword here',
                class: 'col-md-12 col-sm-6 col-12 uploadDropZone',

                name: 'filename',
                type: 'uploadDropZone',

                icon: 'description',
                titleText: 'Upload Image',

                folder: 'aisearch',
                multiple: false,

                webcam: true,
                accept: 'image/*',
            },
        ],
    }
    useEffect(() => {
        if (data.popup) {
            if (
                vin_products &&
                vin_products.from == randomVariable &&
                vin_products.record &&
                vin_products.record.search_data &&
                vin_products.record.search_data.length
            ) {
                vin_products.record.search_data.map((ele) => {
                    ele.description = vin_products.record.description
                })
                updateCount('ai_search')
                setTableBody(vin_products.record.search_data)
                setIsLoading(false)
            } else {
                setTableBody([])

                setIsLoading(false)
                // setAlert('No records Found', 'error')
            }
        }

        return () => setTableBody([])
    }, [vin_products])
    useEffect(() => {
        if (data.popup) {
            if (
                image_products &&
                image_products.from == randomVariable &&
                image_products.record &&
                image_products.record.search_data &&
                image_products.record.search_data.length
            ) {
                image_products.record.search_data.map((ele) => {
                    ele.description = image_products.record.description
                })
                updateCount('ai_search')
                setTableBody(image_products.record.search_data)
                setIsLoading(false)
            } else {
                setTableBody([])
                setIsLoading(false)
                // setAlert('No records Found', 'error')
            }
        }

        return () => setTableBody([])
    }, [image_products])
    useEffect(() => {
        if (data.popup) {
            if (
                ai_products &&
                ai_products.from == randomVariable &&
                ai_products.record &&
                ai_products.record.search_data &&
                ai_products.record.search_data.length
            ) {
                ai_products.record.search_data.map((ele) => {
                    ele.description = ai_products.record.description
                })
                updateCount('ai_search')
                setTableBody(ai_products.record.search_data)
                setIsLoading(false)
            } else {
                setTableBody([])
                setIsLoading(false)
                // setAlert('No records Found', 'error')
            }
        }

        return () => setTableBody([])
    }, [ai_products])
    const closeFunction = (data) => {
        toggleCatalogPopup(data || false)
        setTableBody([])
        formik.values.title = ''
        randomVariable = Math.random()
    }
    const ShowBalance = ({ data }) => {
        const date = new Date()
        const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1)

        return data ? (
            <div className="customProgress">
                <LinearProgress
                    variant="determinate"
                    value={data.percent ? data.percent : 0}
                />
                <p className="cpLeft">
                    <span>{data.used}</span> / {data.limit} used
                </p>
                <p className="cpLeft">
                    <span>{data.balance} Left.</span> Reset on{' '}
                    {nextMonth.toDateString()}
                </p>
            </div>
        ) : null
    }

    useEffect(() => {
        if (data?.popup) {
            setPluginCountDetails(null)

            getTableDataDynamic()
        }
    }, [data?.popup])
    useEffect(() => {
        if (showPluginCount.length) {
            if (table_data && table_data.records && table_data.records.length) {
                let showData = {}
                table_data.records.map((ele) => {
                    if (ele.payments) {
                        if (showPluginCount.includes(ele.name)) {
                            showData[ele.name] = {
                                limit: ele.max_limit ? ele.max_limit : 0,
                                used: ele.use_count ? ele.use_count : 0,
                                balance: ele.enable
                                    ? ele.max_limit - ele.use_count
                                    : 0,
                                enable: ele.enable,
                                percent: (ele.use_count / ele.max_limit) * 100,
                            }
                        }
                    }
                })
                setPluginCountDetails(showData)
            }
        }
    }, [table_data])
    const makePaymentFn = (data) => {
        handleRedirectInternal(history, `billing/${data ? data : 'all'}/0`)
    }

    const AITextSearch = (text) => {
        formik.setFieldValue('title', text)
        setTimeout(() => {
            formik.submitForm()
        }, 1200)
    }

    const AIImageSearch = (text) => {
        formik.setFieldValue('filename', [text])
        setTimeout(() => {
            formik.submitForm()
        }, 1200)
    }
    return (
        <FullScreenPopup
            modaltitle={
                value == 1
                    ? 'VIN Number Search'
                    : value == 2
                    ? 'AI Image Search'
                    : `AI Search`
            }
            open={data.popup}
            className="inventoryErpCnt"
            handleClose={() => closeFunction()}
        >
            {pluginCountDetails && pluginCountDetails['ai_search'] ? (
                <ShowBalance data={pluginCountDetails['ai_search']} />
            ) : null}

            <div className="erpTabs">
                <AppBar position="static">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="ERP Tabs"
                    >
                        <Tab label="AI Search" {...a11yProps(0)} />
                        <Tab label="VIN Number Search" {...a11yProps(1)} />
                        <Tab label="AI Image Search" {...a11yProps(2)} />
                    </Tabs>
                </AppBar>
            </div>
            <div className="addUserModal">
                <div className="dashboard listing">
                    {/* {pluginCountDetails &&
                    pluginCountDetails['asin'] &&
                    pluginCountDetails['asin'].enable == 0 ? (
                        <div className="col-auto ml-auto btnSearch">
                            <PrimaryButton
                                id="fetch"
                                label="Make Payment"
                                btnSize="small"
                                onClick={() => makePaymentFn('asin')}
                            />
                        </div>
                    ) : ( */}

                    {value === 0 ? (
                        <div className="mainSeachExCnt">
                            <h2>Example: Search for Terms like</h2>
                            <div className="searchExCnt">
                                Rolex Submariner Hulk Green Dial Mens Luxury
                                Watch{' '}
                                <span
                                    className="material-icons cursorDecoy"
                                    onClick={() =>
                                        AITextSearch(
                                            'Rolex Submariner Hulk Green Dial Mens Luxury Watch'
                                        )
                                    }
                                >
                                    search
                                </span>
                            </div>
                            <div className="searchExCnt">
                                Barista Brew Semi Automatic Espresso Machine{' '}
                                <span
                                    className="material-icons cursorDecoy"
                                    onClick={() =>
                                        AITextSearch(
                                            'Barista Brew Semi Automatic Espresso Machine'
                                        )
                                    }
                                >
                                    search
                                </span>
                            </div>
                            <div className="searchExCnt">
                                Dell Inspiron 3020 Desktop - Intel Core i7{' '}
                                <span
                                    className="material-icons cursorDecoy"
                                    onClick={() =>
                                        AITextSearch(
                                            'Dell Inspiron 3020 Desktop - Intel Core i7'
                                        )
                                    }
                                >
                                    search
                                </span>
                            </div>
                        </div>
                    ) : value === 1 ? (
                        <div className="mainSeachExCnt">
                            <h2> Example: Search for Terms like</h2>
                            <div className="searchExCnt">
                                1FM5K8AT0JGA83912 (2018 Ford Explorer){' '}
                                <span
                                    className="material-icons cursorDecoy"
                                    onClick={() =>
                                        AITextSearch('1FM5K8AT0JGA83912')
                                    }
                                >
                                    search
                                </span>
                            </div>
                            <div className="searchExCnt">
                                2C4RDGBG9ER187816 (2014 Dodge Grand Caravan){' '}
                                <span
                                    className="material-icons cursorDecoy"
                                    onClick={() =>
                                        AITextSearch('2C4RDGBG9ER187816')
                                    }
                                >
                                    search
                                </span>
                            </div>
                            <div className="searchExCnt">
                                1GTN1LEH8GZ308820 (2016 GMC Sierra 1500){' '}
                                <span
                                    className="material-icons cursorDecoy"
                                    onClick={() =>
                                        AITextSearch('1GTN1LEH8GZ308820')
                                    }
                                >
                                    search
                                </span>
                            </div>
                        </div>
                    ) : value === 2 ? (
                        <div className="mainSeachExCnt">
                            <h2> Example: Search for Terms like</h2>
                            <div className="searchExCnt image">
                                <div className="searchExImageDiv">
                                    <div className="searchExImage">
                                        <img src="https://largeproductapi-test.ecommerce.auction/uploads/aisearch/file_upload-1725959368053_566239.jpeg" />
                                    </div>{' '}
                                    Logitech G PRO Mechanical Gaming Keyboard{' '}
                                </div>
                                <span
                                    className="material-icons cursorDecoy"
                                    onClick={() =>
                                        AIImageSearch(
                                            'file_upload-1725959368053_566239.jpeg'
                                        )
                                    }
                                >
                                    search
                                </span>
                            </div>
                            <div className="searchExCnt image">
                                <div className="searchExImageDiv">
                                    <div className="searchExImage">
                                        <img src="https://largeproductapi-test.ecommerce.auction/uploads/aisearch/file_upload-1725959938292_539336.jpeg" />
                                    </div>{' '}
                                    Apple Watch SE{' '}
                                </div>

                                <span
                                    className="material-icons cursorDecoy"
                                    onClick={() =>
                                        AIImageSearch(
                                            'file_upload-1725959938292_539336.jpeg'
                                        )
                                    }
                                >
                                    search
                                </span>
                            </div>
                        </div>
                    ) : null}

                    <CustomSearch
                        searchInfo={value == 2 ? searchInfoImage : searchInfo}
                        makePayment={
                            pluginCountDetails &&
                            pluginCountDetails['ai_search'] &&
                            pluginCountDetails['ai_search'].enable == 0
                                ? true
                                : false
                        }
                        buttonLabel={
                            pluginCountDetails &&
                            pluginCountDetails['ai_search'] &&
                            pluginCountDetails['ai_search'].enable == 0
                                ? 'Make Payment'
                                : 'Search'
                        }
                        pluginName="ai_search"
                        makePaymentFn={makePaymentFn}
                        formik={formik}
                    />

                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            {tableBody.length > 0 ? (
                                // <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4 mb-4">
                                tableBody.map((data) => <AiView data={data} />)
                            ) : (
                                // </div>
                                <NoRecordsFound></NoRecordsFound>
                            )}
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default AiSearch
